import React from 'react'
import { useEffect, useState  } from "react";
import UIkit from "uikit";
import Cookies from "js-cookie";
import { useAuth } from '../../Context/AuthProvider';
import { url } from '../../Constant';
import { toast } from "react-toastify";
import axios from "axios";

const Password = () => {
    const [loader, setLoader] = useState(false);
    const [errorEnable, setErrorEnable] = useState(false);
    const [passwordRequired, setPasswordRequired] = useState(false);
    const [cnfrmPasswordRequired, setCnfrmPasswordRequired] = useState(false);
    const [passwordError, setPasswordError] = useState("");
    const [pwdPassword, setPwdPassword] = useState("valid");
    const [userPassword, setuserPassword] = useState();
    const [submittedData, setSubmittedData] = useState({
        password: "",
        password_confirm: "",
      });
    const { auth } = useAuth();
    useEffect(() => {
      var trVal = sessionStorage.getItem("ct_licked");
      UIkit.switcher("#renderSwitcher").show(trVal);
    }, []);



    const handleLogout = () => {
      // Make a POST request to the logout endpoint
      axios.post(url + `auth/logout`, 
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        }
       
      )
        .then((response) => {
          if (response.status === 200) {
            // Successfully logged out, perform any additional actions here
            sessionStorage.clear("/");
            localStorage.clear("/");
            Cookies.remove(
              "YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD",
              { path: "/" }
            );
            // Redirect to the home page or any other destination
            window.location.href = "/";
          } else {
            // Handle the case where logout failed (e.g., show an error message)
            console.error("Logout failed");
          }
        })
        .catch((error) => {
          // Handle any network or other errors
          console.error("Network error:", error);
        });
    };
  
      
      const createPassword = (e) => {
        e.preventDefault(); 
        
        setErrorEnable(true);
        setLoader(true);
        
        var formData = new FormData();
        formData.append("new_password", submittedData.password);
        formData.append("vpbx_id", auth.vpbx_id);
        formData.append("password_confirmation", submittedData.password_confirm);
      
        if (submittedData.password !== "" && submittedData.password_confirm !== "") {
          axios
            .post(url + "change_password", formData, {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            })
            .then((response) => {
              if (response.data.code === 200) {
                if (response.data.message === "Password Change Successfully") {
                  setLoader(false);
                  toast.success(response.data.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  });
                  setTimeout(() => {
                    handleLogout();
                    // window.location.href = "/vpbx-manager";
                  }, 2000);
                } else {
                  // If the message property is not as expected, show an error message
                  toast.error("Unexpected response from the server", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  });
                }
              } else {
                // Handle other response codes (if needed)
                const errors = response?.data?.data?.errors;
                const emailError = response?.data?.data?.email;
      
                if (errors) {
                  toast.error(errors[0] || emailError || "An error occurred", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  });
                } else if (emailError) {
                  toast.error(emailError, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  });
                } else {
                  toast.error("An error occurred", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  });
                }
              }
            })
            .catch((error) => {
              console.log(error);
              // Handle other errors (e.g., network errors)
              toast.error("An error occurred", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
            })
            .finally(() => {
              setLoader(false);
            });
        } else {
          // Handle password fields being empty
          setLoader(false);
          toast.error("Password fields cannot be empty", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
        }
      };
      


    const handleConfirmPwdValidation = (e) => {
        if (e === submittedData.password && e.length >= 5) {
          setPwdPassword("valid");
        } else {
          setPwdPassword("invalid");
        }
    
        if (submittedData.password !== "") {
          setPasswordRequired(false);
        } else {
          setPasswordRequired(true);
        }
        if (e === "") {
          setCnfrmPasswordRequired(true);
        }
        if (e !== "") {
          setCnfrmPasswordRequired(false);
        }
    
        if (e === "" && submittedData.password === "") {
          setPasswordRequired(false);
          setCnfrmPasswordRequired(false);
          setPwdPassword("valid");
        }
      };
      const handlePasswordValidation = (e) => {
        const passwordRegex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/;
        let testedPassword = passwordRegex.test(e);
    
        if (testedPassword === false) {
          setPasswordError("Validation error");
        } else if (e.length < 14) {
          setPasswordError("Invalid password");
        } else {
          setPasswordError("");
        }
        if (submittedData.password_confirm !== "") {
          setCnfrmPasswordRequired(false);
        } else {
          setCnfrmPasswordRequired(true);
        }
        if (e === "") {
          setPasswordRequired(true);
        }
    
        if (e === submittedData.password_confirm) {
          setPwdPassword("valid");
        } else {
          setPwdPassword("invalid");
        }
    
        if (e === "") {
          setPasswordRequired(true);
        }
        if (e !== "") {
          setPasswordRequired(false);
        }
    
        if (e === "" && submittedData.password_confirm === "") {
          setPasswordRequired(false);
          setCnfrmPasswordRequired(false);
          setPasswordError("");
        }
      };
  return (
    <div className="dashboardWrp">
    <div className="uk-container uk-container-large">
      <div className="dashboardTop">
        <div uk-grid="" className="uk-grid uk-grid-small">
          <div className="uk-width-2-3">
            <div className="dashboardIntro">
              <h3>PROFILE DETAILS</h3>
              {auth.role === "2" && (
                <p>
                  Use this page to create new password.
                </p>
              )}
              {auth.role === "1" && (
                <p>
                  Use this page to create new password.
                </p>
              )}
            </div>
          </div>
          {/* <div className="uk-width-1-3">
            <div className="dashboardIntro uk-text-right">
              <button>EXPORT DATA</button>
            </div>
          </div> */}

          <div className="uk-width-1-1 ">
            <ul
              className="uk-subnav callSwitcher"
              // className="uk-subnav uk-subnav-pill"
              id="renderSwitcher"
              uk-switcher="connect: .callClass"
            >
              {auth.role === "2" && (
                <>
                  <li
                    onClick={() => sessionStorage.setItem("ct_licked", 0)}
                  >
                    <a href="#">Password Change</a>
                  </li>
                </>
              )}
              {auth.role === "1" && (
                <>
                  <li
                    onClick={() => sessionStorage.setItem("ct_licked", 0)}
                  >
                    <a href="#">Password Change</a>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
        <ul className="uk-switcher uk-margin callClass">
          {auth.role === "2" && (
            <>
              <li>
                
              <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>Password Change</h3>
              </div>
            </div>
            
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                {/* <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Add details</legend>
                </div> */}
               <div className="uk-width-1-2@m uk-margin-top">
                  <label>Password</label>
                  <input
                    className="uk-input"
                    type="password"
                    aria-label="Input"
                    placeholder="Enter Password"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password: e.target.value,
                      });
                      handlePasswordValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.password === "" && (
                    <div className="formErrors">Password is required</div>
                  )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Invalid password" && (
                      <div className="formErrors">
                        password must be 14 characters
                      </div>
                    )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Validation error" && (
                      <div className="formErrors">
                        password must includes uppercase, lowercase, numbers and
                        special characters
                      </div>
                    )}
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Confirm password</label>
                  <input
                    className="uk-input"
                    type="password"
                    aria-label="Input"
                    placeholder="enter confirm password"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password_confirm: e.target.value,
                      });
                      handleConfirmPwdValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.password_confirm === "" && (
                    <div className="formErrors">
                      Confirm Password is required
                    </div>
                  )}
                  {submittedData.password_confirm !== "" &&
                    errorEnable &&
                    pwdPassword === false && (
                      <div className="formErrors">
                        Password and Confirm Password not matched{" "}
                      </div>
                    )}
                </div>

                <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                  <div className="formActionBtn uk-text-right">
                    <button className="pinkBtn" onClick={createPassword}>
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Update"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
                {/* <CreateIVR /> */}
              </li>
            </>
          )}
          {auth.role === "1" && (
            <>
              <li>
                {/* <Companies /> */}
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  </div>
  )
}

export default Password